module.exports = __webpack_public_path__ + "img/cige_logo.77f29a8c.webp";